import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <div className="section-lux container-lux text-center grid-glow">
      <div className="font-display text-8xl font-extrabold gold-text">404</div>
      <h1 className="text-2xl font-bold text-white mt-4">Page Not Found</h1>
      <p className="text-slate-400 mt-3 max-w-md mx-auto">The page you're looking for doesn't exist or has moved.</p>
      <Link to="/" className="gold-btn mt-8 inline-flex" data-testid="notfound-home-btn"><Home size={16} /> Back Home</Link>
    </div>
  );
}
